<div class="footer-container">
  <span class="footer-text">{{ copyright }}</span>
</div>
